<!--  -->
<template>
 <div class="toApply">
  <crumbs/>
  <div class="container">
      <div class="bgfff mb100">
          <div class="declarebtn clearfix">
              <a href="javascript:;" class="gradientfour">常用申报人列表</a>
              <a href="javascript:;" class="addreport gradientfour"
              @click="dialogTableVisible2 = true"
              ><i></i>新增申报人</a>
          </div>
          <div class="checkBoxs">
            <div class="checkBoxsItem" v-for='(item,index) in checkList'  :key="index">
                <el-checkbox  v-model="item.sta" @change="changeBoxs(index)">{{item.name}}</el-checkbox>
            </div>

          </div>

          <div class="tablesBox">
              <el-table
                :data="checkLists"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="200"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="idCard"
                  label="证件号"
                  width="300"
                  align="center"
                  :formatter="formatID">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="手机号"
                   width="260"
                   align="center">
                </el-table-column>
                 <el-table-column
                  label="操作"
                  width="170">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <div class="dbttom">
            <div class="title"><span>申报信息</span><i></i></div>
            <el-form ref="formone"    :model="form" label-width="80px"  label-position="top" class="forms" :rules="rules">
              <div class="fl leftBox">
                 <el-form-item label="项目名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="属地" prop="area">
              <el-input v-model="form.area"></el-input>
            </el-form-item>
            <el-form-item label="保护单位" prop="protect">
              <el-input v-model="form.protect"></el-input>
            </el-form-item>
            <el-form-item label="法人" prop="faren">
              <el-input v-model="form.faren"></el-input>
            </el-form-item>
            <el-form-item label="通讯地址" prop="contact">
              <el-input v-model="form.contact"></el-input>
            </el-form-item>
              </div>
              <div class="fl">
            <el-form-item label="电子邮箱" prop="emile">
              <el-input v-model="form.emile"></el-input>
            </el-form-item>
             <el-form-item label="单位电话" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="附件上传">
              <el-upload
                class="upload-demo"
                drag
                action
                multiple
                :on-remove="handleRemove"
                 :on-success="handleSucc"
                :http-request="upLoadfiles">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text"><em>点击上传</em></div>
              </el-upload>
            </el-form-item>
              </div>
          </el-form>
          </div>

          <div class="confirmdiv">
            <a href="javascript:;" id="cbtn" class="gradientfour" @click="gosubmit"
            v-loading="loading"
            >提交申报</a>
            <p><input type="checkbox" id="readflag" v-model="ifReadBtn"><a id="readbtn" @click="dialogTableVisible= true">我已阅读并悉知申报流程。</a></p>
           </div>
        <el-dialog title="关于非遗项目申报的通知" :visible.sync="dialogTableVisible">
          <div class="contdia" v-html="$route.query.additionalContent">

              </div>

    <div class="dialogBtn">
       <el-button type="success" round @click="ifReadBtn=true;dialogTableVisible=false;">确认</el-button>
         <el-button type="info" round @click="ifReadBtn=false;dialogTableVisible=false;">取消</el-button>
    </div>
</el-dialog>
 <el-dialog  :visible.sync="dialogTableVisible2" width="38%" :destroy-on-close=true>
    <template slot="title">
      <div class="dbttom dialogdb">
          <div class="title"><span>新增申报人</span><i></i></div>
      </div>
     </template>
    <el-form  label-width="80px" :model="addForm" ref="ruleForm" class="diglogform"  :rules="rules2">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="addForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="证件号" prop="idCard">
        <el-input v-model="addForm.idCard"></el-input>
      </el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form>

  </el-dialog>
      </div>
  </div>
 </div>
</template>

<script>
import {addNewPer, addPerList, submitAll, uploads} from '@/api/declare/index'
// import {uploads} from '@/api/mailbox/index'
import crumbs from '@/components/crumbs/index'
export default {
  name: 'toApply',
  meta: {
    showHeader: true
  },
  components: {
    crumbs
  },
  data () {
    return {
      ifReadBtn: true,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      checkLists: [],
      checkList: [],
      addForm: {
        name: '',
        phone: '',
        idCard: ''
      },
      form: {
        name: '',
        area: '',
        protect: '',
        faren: '',
        contact: '',
        emile: '',
        phone: ''
      },
      rules: {
        name: [
          { required: true, message: '请填写项目名称', trigger: 'blur' }
        ],
        name2: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请填写属地', trigger: 'blur' }
        ],
        protect: [{ required: true, message: '请填写保护单位', trigger: 'blur' }],
        faren: [{ required: true, message: '请填写法人', trigger: 'blur' }],
        contact: [{ required: true, message: '请填写通讯地址', trigger: 'blur' }],
        emile: [{ required: true, message: '请填写电子邮箱', trigger: 'blur' }, {
          required: true,
          pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
          message: '格式不正确',
          trigger: 'blur'
        }],
        phone: [{ required: true, message: '请填写联系方式', trigger: 'blur' }, {
          required: true,
          pattern: /^1(3|4|5|7|8)\d{9}$/,
          message: '格式不正确',
          trigger: 'blur'
        }]
      },
      rules2: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        phone: [{ required: true, message: '请填写手机', trigger: 'blur' }, {
          required: true,
          pattern: /^1(3|4|5|7|8)\d{9}$/,
          message: '格式不正确',
          trigger: 'blur'
        }],
        idCard: [{ required: true, message: '请填写证件号', trigger: 'blur' }, {
          required: true,
          pattern: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
          message: '格式不正确',
          trigger: 'blur'
        }]
      },
      addNewPer: {
        name: '',
        phone: '',
        idCard: ''
      },
      menuId: '',
      filesList: [],
      fileUrl: '',
      fileName: '',
      fileList: [],
      loading: false
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.addPerList()
  },
  methods: {
    upLoadfiles (params) {
      console.log(params, 'files')
      this.filesList.push(params)
      this.getFiles()
    },
    getFiles () {
      this.loading = true
      const paramsData = new FormData()
      this.filesList.forEach((it, index) => {
        paramsData.append('file', it.file)
      })
      uploads(paramsData).then(res => {
        console.log(res, 'files')
        if (res.data.data.status === 1) {
          this.fileUrl = res.data.data.download
          this.fileName = res.data.data.name
        } else {
          this.$alert(res.data.data.message, '', {
            confirmButtonText: '确定'
          })
        }

        this.loading = false
      })
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.filesList.forEach((item, index) => {
        if (item.file === file.raw) {
          this.filesList.splice(index, 1)
        }
      })
    },
    handleSucc () {
      // console.log('12233')
    },
    gosubmit () {
      if (this.checkLists.length === 0) {
        this.$alert('请选择申报人', '错误', {
          confirmButtonText: '确定'
        })
      } else if (this.filesList.length === 0) {
        this.$alert('上传附件不能为空', '错误', {
          confirmButtonText: '确定'
        })
      } else {
        this.$refs['formone'].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              let params = {
                menuId: this.menuId,
                userId: this.checkLists[0].id,
                declareName: this.form.name,
                declareId: this.$route.query.declareId,
                territorial: this.form.area,
                protectionUnit: this.form.protect,
                legalPerson: this.form.faren,
                mailingAddress: this.form.contact,
                email: this.form.emile,
                workPhone: this.form.phone,
                attachment: this.fileUrl,
                attachmentName: this.fileName
              }
              submitAll(this.menuId, params).then(res => {
                console.log(res, 'kkk')
                if (res.data.status === 200) {
                  this.$alert(res.data.message, '', {
                    confirmButtonText: '确定',
                    callback: action => {
                      this.$router.push({
                        path: '/managementdeclaration',
                        query: {
                          columnId: this.menuId
                        }
                      })
                    }
                  })
                }
              })
            }, 1000)
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    rulesArray (arr) {
      arr.forEach(item => {
        if (item.sta === undefined) item.sta = false
      })
    },
    submitForm () {
      console.log('123')
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          addNewPer(this.addForm).then(res => {
            console.log(res)
            if (res.data.status === 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              })
              this.addPerList()
              this.dialogTableVisible2 = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addPerList () {
      addPerList().then(res => {
        console.log(res, 'll')
        this.rulesArray(res.data.data)
        this.checkList = res.data.data
      })
    },
    changeBoxs (i) {
      if (this.checkList[i].sta) {
        this.checkLists.push(this.checkList[i])
        this.checkList.forEach(item => {
          item.sta = false
        })
        this.checkList[i].sta = true
        this.checkLists = this.checkLists.filter(item => {
          return item === this.checkList[i]
        })
      } else {
        this.checkLists = this.checkLists.filter(item => {
          return item !== this.checkList[i]
        })
      }
    },
    formatID (row) {
      return row.idCard.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2')
    },
    handleClick (i, v) {
      let index = this.checkList.findIndex(item => {
        return item === v
      })
      this.checkList[index].sta = false
      this.checkLists.splice(i, 1)
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/declare.scss';
</style>



// WEBPACK FOOTER //
// src/view/managementdeclaration/toApply.vue